import { mode } from '@chakra-ui/theme-tools';

export const modalStyles = {
  components: {
    Modal: {
      defaultProps: {
        closeOnOverlayClick: false,
      },
      baseStyle: (props) => ({
        overlay: {
          bg: 'blackAlpha.500',
        },
        dialog: {
          borderRadius: 'md',
          borderWidth: '1px',
          borderColor: mode('gray.200', 'whiteAlpha.200')(props),
          boxShadow: mode(
            '0 4px 24px rgba(0, 0, 0, 0.12)',
            '0 4px 24px rgba(0, 0, 0, 0.4)',
          )(props),
          mx: 3,
          my: 4,
        },
        header: {
          px: 4,
          py: 3,
          borderBottomWidth: '1px',
          borderColor: mode('gray.200', 'whiteAlpha.200')(props),
        },
        body: {
          px: 4,
          py: 3,
        },
        footer: {
          px: 4,
          py: 3,
          borderTopWidth: '1px',
          borderColor: mode('gray.200', 'whiteAlpha.200')(props),
        },
      }),
    },
    AlertDialog: {
      defaultProps: {
        closeOnOverlayClick: false,
      },
    },
    Drawer: {
      defaultProps: {
        closeOnOverlayClick: false,
      },
      baseStyle: (props) => ({
        dialog: {
          boxShadow: mode(
            '-4px 0 24px rgba(0, 0, 0, 0.08)',
            '-4px 0 24px rgba(0, 0, 0, 0.3)',
          )(props),
        },
        header: {
          px: 4,
          py: 3,
          borderBottomWidth: '1px',
          borderColor: mode('gray.200', 'whiteAlpha.200')(props),
        },
        body: {
          px: 4,
          py: 3,
        },
        footer: {
          px: 4,
          py: 3,
          borderTopWidth: '1px',
          borderColor: mode('gray.200', 'whiteAlpha.200')(props),
        },
      }),
    },
  },
};
